import React, { useEffect, useState, useRef, useCallback } from 'react';
import { getProjectById } from '../data/projects';
import './ProjectModal.css';
export default function ProjectModal({ projectId, onClose }) {
  const project = projectId ? getProjectById(projectId) : null;
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [canScroll, setCanScroll] = useState(false);
  const scrollIndicatorRef = useRef(null);
  const modalScrollRef = useRef(null);
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);
  const handleScroll = useCallback((e) => {
    if (scrollIndicatorRef.current && modalScrollRef.current) {
      const scrollTop = e.target.scrollTop;
      if (scrollTop > 20) {
        scrollIndicatorRef.current.classList.add('hidden');
      } else {
        scrollIndicatorRef.current.classList.remove('hidden');
      }
    }
  }, []);
  const checkScrollable = useCallback(() => {
    if (modalScrollRef.current) {
      const { scrollHeight, clientHeight } = modalScrollRef.current;
      setCanScroll(scrollHeight > clientHeight + 10);
    }
  }, []);
  const handleWheel = useCallback((e) => {
    e.stopPropagation();
    const scrollEl = modalScrollRef.current;
    if (!scrollEl) return;
    scrollEl.scrollTop += e.deltaY;
  }, []);
  const handleTouchMove = useCallback((e) => {
    e.stopPropagation();
  }, []);
  useEffect(() => {
    if (!projectId) return;
    const handleEsc = (e) => {
      if (e.key === 'Escape') handleClose();
    };
    window.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    setSelectedImageIndex(0);
    if (modalScrollRef.current) {
      modalScrollRef.current.scrollTop = 0;
    }
    const timer = setTimeout(checkScrollable, 100);
    window.addEventListener('resize', checkScrollable);
    return () => {
      window.removeEventListener('keydown', handleEsc);
      window.removeEventListener('resize', checkScrollable);
      clearTimeout(timer);
      document.body.style.overflow = '';
    };
  }, [projectId, handleClose, checkScrollable]);
  if (!projectId || !project) return null;
  return (
    <div
      className="project-modal-overlay"
      onWheel={handleWheel}
      onTouchMove={handleTouchMove}
    >
      <div className="project-modal">
        {}
        <button className="modal-close" onClick={handleClose}>
          <span></span>
          <span></span>
        </button>
        {}
        {canScroll && (
          <div ref={scrollIndicatorRef} className="modal-scroll-indicator">
            <div className="scroll-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M12 5v14M5 12l7 7 7-7" />
              </svg>
            </div>
          </div>
        )}
        {}
        <div
          ref={modalScrollRef}
          className="modal-scroll"
          onScroll={handleScroll}
        >
          {}
          <section className="modal-hero">
            <div className="hero-media">
              <img
                src={project.images[selectedImageIndex]}
                alt={project.title}
                loading="lazy"
                onError={(e) => {
                  e.target.src = `/img/img/${project.textureIndex + 1}.jpg`;
                }}
              />
            </div>
            <div className="hero-overlay">
              <h1 className="hero-title">{project.title}</h1>
            </div>
          </section>
          {}
          <div className="hero-thumbnails">
            {project.images.slice(0, 3).map((image, index) => (
              <div
                key={index}
                className={`hero-thumb ${selectedImageIndex === index ? 'active' : ''}`}
                onClick={() => setSelectedImageIndex(index)}
              >
                <img
                  src={image}
                  alt={`${project.title} ${index + 1}`}
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = `/img/img/${project.textureIndex + 1}.jpg`;
                  }}
                />
              </div>
            ))}
          </div>
          {}
          <section className="modal-info">
            <div className="info-grid">
              {}
              <div className="info-main">
                <p className="info-description">{project.description}</p>
              </div>
              {}
              <div className="info-meta">
                <div className="meta-group">
                  <span className="meta-label">Tech Used:</span>
                  <ul className="meta-list">
                    {project.techStack.map((tech, i) => (
                      <li key={i}>{tech}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </section>
          {}
          {project.features && project.features.length > 0 && (
            <section className="modal-features">
              <h3 className="section-label">Key Features</h3>
              <ul className="features-list">
                {project.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
            </section>
          )}
          {}
          <section className="modal-cta">
            {project.liveUrl && (
              <a
                href={project.liveUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-btn cta-primary"
              >
                <span>Launch Project</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M7 17L17 7M17 7H7M17 7V17" />
                </svg>
              </a>
            )}
          </section>
          {}
          {}
        </div>
      </div>
    </div>
  );
}